import {
  GetCategoryCpg_CachedQuery,
  GetCategoryCpg_CachedQueryVariables
} from '@data/__generated__/types.main'
import productListInformationFragment from '@data/fragments/products/productListInformation.main'
import hasWebpSupport from '@helpers/misc/hasWebpSupport'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export interface Props {
  categoryId?: string
  menuId?: string
  storeId?: string
  deliverAt?: Date
}

export default function useCategoryCPG(props: Props) {
  const {categoryId, storeId, deliverAt, menuId} = props
  const format = hasWebpSupport() ? 'webp' : 'jpeg'

  const variables = {
    categoryId,
    menuId,
    storeId,
    deliverAt,
    format,
    limit: null
  }

  const {category, loading} = useApolloQuery<
    GetCategoryCpg_CachedQuery,
    GetCategoryCpg_CachedQueryVariables
  >({
    query: gql`
      query getCategoryCPG_cached(
        $categoryId: ID
        $menuId: ID
        $storeId: ID
        $deliverAt: Date
        $format: String
        $limit: Float
      ) {
        category(categoryId: $categoryId) {
          _id
          name
          paginatedProducts(
            menuId: $menuId
            storeId: $storeId
            deliverAt: $deliverAt
            limit: $limit
          ) {
            items {
              _id
              modifiers {
                _id
                optional
              }
              categories {
                _id
                name
                internalName
              }
              ...productListInformation
            }
          }
        }
      }
      ${productListInformationFragment}
    `,
    variables,
    fetchPolicy: 'cache-first',
    omit: isServerSide()
  })

  return {category, loading}
}
